import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { PagePermissions } from 'src/app/shared/models/permissions';
import { LandingModulesNames, MenuItem, ModulePage, ModulePageOpen } from '@shared/models/modules-landing.model';
import { Subscription } from 'rxjs';
import { RolesEnum } from 'src/app/shared/models/roles';
import { PagesMenuService } from '@shared/services/pages-menu.service';
import { PageMenuDateService } from '@shared/services/page-menu-date.service';
import { Router } from '@angular/router';
import { ModuleActivationService } from '@core/services/module-activation.service';

@Component({
  selector: 'app-modules-landing-controller',
  template: '',
})
export class ModulesLandingControllerComponent implements AfterViewInit, OnDestroy {

  menuItems: MenuItem[] | any[] = [...this.menuService.menu_items]
  starredPages: ModulePage[] = [];
  openedPages: ModulePageOpen[] = [];
  subscriptions: Subscription[] = [];
  isPointOfSaleV3Enabled: boolean = false;
  landingModulesNames = LandingModulesNames;

  constructor(
    public menuService: PagesMenuService,
    private moduleActivationService: ModuleActivationService,
    public pageMenuDateService: PageMenuDateService,
    public route: Router
  ) {
    this.menuService.loadStarredPages();
  }

  public get pagePermissions(): typeof PagePermissions {
    return PagePermissions;
  }

  public get roles(): typeof RolesEnum {
    return RolesEnum;
  }

  ngAfterViewInit(): void {
    this.loadSettings();

    const starredPages$ = this.menuService.starredPages$.subscribe((res: ModulePage[]) => {
      this.starredPages = res;
      this.menuService.menuItemsMapper([...this.menuItems]);
    });

    const openedPages$ = this.pageMenuDateService.openedPages$.subscribe((res: ModulePageOpen[]) => {
      this.openedPages = res;
      this.pageMenuDateService.menuItemsMapper([...this.menuItems]);
    });

    this.subscriptions.push(starredPages$);
    this.subscriptions.push(openedPages$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub?.unsubscribe());
  }

  onToggleStarred(isStarred: boolean, data: ModulePage, moduleItem: MenuItem) {
    this.menuService.onToggleStarred(isStarred, data, moduleItem);
  }

  onRouteLastTimeClicked(moduleItem: ModulePageOpen | any) {
    this.pageMenuDateService.getClickedDate(moduleItem.id);
  }

  private async loadSettings() {
    this.isPointOfSaleV3Enabled = await this.moduleActivationService.isPointOfSaleV3Enabled();
    this.menuService.loadStarredPagesList();
    this.pageMenuDateService.loadOpenedPagesList();
  }
}
